<!-- Button -->
<button mat-button [matMenuTriggerFor]="userActions">
    <div class="flex items-center gap-2">
        <!-- User name - visible only on desktop -->
        <span class="hidden md:block text-sm">
            {{ user()?.name }}
        </span>

        <span class="relative">
            @if (showAvatar && avatarUrl()) {
                <img class="h-7 w-7 rounded-full object-cover" [src]="avatarUrl()!" alt="Photo de profil" />
            } @else {
                <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
            }
            <span
                class="absolute bottom-0 right-0 h-2 w-2 rounded-full"
            ></span>
        </span>
    </div>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <p>Connecté en tant que</p>
            <span class="mt-1.5 text-md font-medium">{{ user()?.email }}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="goToProfile()">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>Mon Profil</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>Se déconnecter</span>
    </button>
</mat-menu>